export const FundingPurposeType = Object.freeze({
  dayToDay: 1,
  businessExpansion: 2,
  assetFinance: 3,
  refinancing: 4,
  importExport: 5,
  taxBillDue: 6,
  acquiringBusiness: 7,
  startingBusiness: 8,
  purchasingProperty: 9,
  purchasingStock: 10,
  none: 11,
  cashFlow: 'CASH_FLOW',
});

export const FundingPurposeTypeLabel = Object.freeze({
  [FundingPurposeType.dayToDay]: 'Day to day cashflow',
  [FundingPurposeType.businessExpansion]: 'Business expansion',
  [FundingPurposeType.assetFinance]: 'Equipment/Asset finance',
  [FundingPurposeType.refinancing]: 'Refinancing debt',
  [FundingPurposeType.importExport]: 'Import/Export',
  [FundingPurposeType.taxBillDue]: 'Tax bill due',
  [FundingPurposeType.acquiringBusiness]: 'Acquiring a business',
  [FundingPurposeType.startingBusiness]: 'Starting a business',
  [FundingPurposeType.purchasingProperty]: 'Purchasing a property',
  [FundingPurposeType.purchasingStock]: 'Purchasing stock',
  [FundingPurposeType.none]: 'None',
});

export const FundingPurposeTypeDescription = Object.freeze({
  [FundingPurposeType.dayToDay]:
    'Suitable for businesses who need to fund certain recurring operations in their company. Cashflow funding can help cover short term liabilities such as paying staff wages to meeting rent demands.',
  [FundingPurposeType.businessExpansion]:
    'Funding is a vital part of business growth, and while each small business might have a different journey towards expansion, financing will still be required each step of the way. Very suitable for businesses who need to balance production capacity to meet demand, looking to drive new innovation or expand their workforce.',
  [FundingPurposeType.assetFinance]:
    'A type of lending designed for businesses who require access to assets such as machinery, equipment and vehicles, or alternatively for businesses who wish to release cash from existing assets that already owned.',
  [FundingPurposeType.refinancing]:
    'Suitable for businesses with existing credit facilities who are seeking a better interest rate to reduce their monthly payments or the repayment term agreed, or to consolidate existing facilities into a single loan with approved terms.',
  [FundingPurposeType.importExport]:
    'Trading internationally can significantly increase the financial risks a business is exposed to, including currency fluctuations and delivery delays. Import and Export funding can help relieve the financial burden and risks a business encounters selling goods overseas.',
  [FundingPurposeType.taxBillDue]:
    'Relieve the financial burden of meeting tax liabilities for VAT and Corporation Tax by utilising a short term finance facility.',
  [FundingPurposeType.acquiringBusiness]:
    "Suitable for companies looking to acquire a business to add to their existing portfolio or as a means to bolster their proposition. If you don't have the sufficient funds to make the purchase, there are different finance options to support you.",
  [FundingPurposeType.startingBusiness]:
    'Suitable for early stage businesses looking for finance to build up funds to get started in business and have a solid financial base. Can support with arising short term needs and to make the most of early opportunities to grow.',
  [FundingPurposeType.purchasingProperty]:
    'A type of lending designed for property developers and investors to help get their next project off the ground. Suitable for the purchase of a new commercial property or from light to extensive refurbishment.',
  [FundingPurposeType.purchasingStock]:
    'Suitable for businesses that sell tangible products, such as retail stores and wholesalers who are looking to purchase additional inventory. This type of lender is usually targeted towards businesses that has a history of purchasing stock.',
});

export function toOptions() {
  return Object.values(FundingPurposeType).map((value) => ({
    label: FundingPurposeTypeLabel[value],
    value,
  }));
}

export function toOptionsUiSchema() {
  return Object.entries(FundingPurposeTypeLabel).map(([value, label]) => ({ label, value }));
}
